import { F as e, R as t, U as n, rt as r, t as i, v as a, w as o } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/common/Button.ce.vue?vue&type=script&setup=true&lang.ts
var s = ["aria-disabled"], c = /*#__PURE__*/ i(/* @__PURE__ */ o({
	__name: "Button.ce",
	props: { isDisabled: { type: Boolean } },
	setup(i, { expose: o }) {
		let c = n("button");
		function l(e) {
			i.isDisabled && e.stopPropagation();
		}
		function u() {
			c.value.focus();
		}
		return o({
			buttonElement: c,
			focus: u
		}), (n, o) => (e(), a("button", {
			ref: "button",
			"aria-disabled": i.isDisabled,
			class: r({ "is-disabled": i.isDisabled }),
			type: "button",
			onClickCapture: l
		}, [t(n.$slots, "default", {}, void 0, !0)], 42, s));
	}
}), [["styles", ["button[data-v-969d20bf]{color:#fff;background:#253858;border:none;border-radius:8px;padding:8px 24px}button[data-v-969d20bf]:hover{cursor:pointer;background:#334d77}button.is-disabled[data-v-969d20bf]{cursor:not-allowed;background:#25385880}"]], ["__scopeId", "data-v-969d20bf"]]);
//#endregion
export { c as t };
